import { Card, CardBody, chakra, CardHeader, Flex, Button, Box, Text, useColorMode } from '@chakra-ui/react'
import React from 'react'
import { getColor, colorKeys } from "../../../config/constants/appColors"
import PrimaryButton from '../../../components/BasicUI/Buttons/PrimaryButton'
import FormInput from "../../../components/Forms/FormInput"
import { useForm } from 'react-hook-form'
import { Link, useNavigate } from 'react-router-dom'
import { Post } from '../../../config/api/Post'
import API_CONSTANTS from '../../../config/constants/api'
import { toast } from 'react-toastify'
import { addUser, updatePermissionsMap } from '../../../config/redux/slices/userSlice'
import { useDispatch } from 'react-redux'
import { useLogin } from '../../../config/query/authQuery'
import { EMAIL_REGEX } from '../../../config/constants/regexConstants'

const Login = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { colorMode } = useColorMode()

    const loginQuery = useLogin()

    const {
        handleSubmit,
        control,
        formState: { errors },
    } = useForm()

    function onSubmit(values) {
        loginQuery.mutateAsync(values)
            .then((response) => {
                console.log(response, "response")
                const permissions = response?.permissions

                const permissionsMap = {}

                permissions?.forEach((item) => {
                    const splitted = item.split(".")
                    const module = splitted[0]
                    const action = splitted[1]

                    if (!permissionsMap[module]) {
                        permissionsMap[module] = {}
                    }

                    permissionsMap[module][action] = true
                })

                console.log(permissionsMap, "kjlasjdlkasjdlkasjdklasjd")
                
                dispatch(updatePermissionsMap(permissionsMap))
                dispatch(addUser(response))
                navigate("/admin")
            })
            .catch((error) => {
                console.log(error, "error")
            })
    }

    return (
        <Flex height={"calc(100vh - 60px)"} justify="center" align="center" bg={getColor(colorKeys.lightBackgroundFill, colorMode)}>
            <Box w={{ base: "95%", md: "460px" }}>
                <Card minW={{ base: "95%", md: "460px" }} my="4rem">
                    <CardHeader
                        border={`1px solid ${getColor(colorKeys.lightGrayBackgroundFill, colorMode)}`}
                        bg={getColor(colorKeys.lightGrayBackgroundFill, colorMode)}
                        color={getColor(colorKeys.primaryText, colorMode)}
                        fontSize={"22px"}
                        fontWeight="bold"
                        p="13px 30px"
                    >
                        Log in
                    </CardHeader>
                    <CardBody bg={getColor(colorKeys.layoutBoxBackground, colorMode)}>
                        <chakra.form onSubmit={handleSubmit(onSubmit)}>

                            <FormInput
                                id={"Email"}
                                label="Email"
                                placeholder="someone@example.com"
                                required={true}
                                errors={errors}
                                control={control}
                                rules={{
                                    pattern: {
                                        value: EMAIL_REGEX,
                                        message: "invalid email address"
                                    }
                                }}
                            />

                            <FormInput
                                id={"Password"}
                                type="password"
                                label="Password"
                                placeholder="********"
                                required={true}
                                errors={errors}
                                control={control}
                                containerStyles={{ mt: 5 }}
                            />

                            <Link to="/forgot-password">
                                <Box textAlign={"right"} mt={5} color={getColor(colorKeys.primaryButtonFill, colorMode)} fontSize={"15px"} >Forgot password?</Box>
                            </Link>

                            <PrimaryButton
                                isLoading={loginQuery.isLoading} mt={5} type="submit" p="18px 33px"
                                bg={getColor(colorKeys.primaryButtonFill, colorMode)}
                                w="full" h="50px" rounded="full" fontWeight={"bold"} color="white"
                            >
                                Login
                            </PrimaryButton>


                        </chakra.form>
                    </CardBody>
                </Card>


                <Box fontSize="15px" color={getColor(colorKeys.primaryText, colorMode)} textAlign="center">
                    <Text>Haven't registerd yet?</Text>

                    <Flex textAlign={"center"} justify="center">

                        <Link to="/register">
                            <Button variant="link" type="button" color={getColor(colorKeys.primaryButtonFill, colorMode)}>
                                Create an account
                            </Button>
                        </Link>
                        <Text ml={1}> and spread your wings</Text>
                    </Flex>
                </Box>

            </Box>


        </Flex>
    )
}

export default Login